<template>
  <div class="access-denied-view">
    <v-container fluid>
      <breadcrumbs />
    </v-container>
    <div class="access-denied-view_inner">
      <img src="/img/403-icon.svg" />
      <div class="access-denied-view_text">
        У вас нет прав для доступа к этой странице
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AccessDenied',
  }
</script>

<style scoped lang="less">
.access-denied-view {
  padding-top: 30px;
  // заглушка стоит в верхней трети экрана, а не по центру
  &_inner {
    height: calc(100vh - 200px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 15vh;
    flex-grow: 1;

    img {
      max-width: 100%;
      max-height: 100%;
      margin-bottom: 40px;
    }
  }

  &_text {
    font-weight: 300;
    font-size: 24px;
    text-align: center;
  }

}
</style>
